import { Component } from '@angular/core';

@Component({
  selector: 'gplus-icon-cloud-loading',
  imports: [],
  templateUrl: './icon-cloud-loading.component.html',
  styleUrl: './icon-cloud-loading.component.scss',
})
export class IconCloudLoadingComponent {

}
